import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { CartUIProvider } from "./context/CartUIContext";
import { CartProvider } from "./components/context/CartContext";
import { Provider } from "react-redux";
import store from "./ReduxToolkit/store.jsx";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <CartProvider>
        <CartUIProvider>
          {" "}
          {/* ✅ ADD THIS */}
          <App />
        </CartUIProvider>
      </CartProvider>
    </Provider>
  </React.StrictMode>,
);

reportWebVitals();
